import { findParentNodeClosestToPos } from "@tiptap/core";
import { TIPTAP_FIGURE_TYPE, TIPTAP_VIDEO_TYPE } from "./../../ricos-content/index.js";
import { createRicosNodeExtension } from "./../../plugin-commons/index.js";
import { Video } from "./component.js";
const tiptapExtensions = [
  createRicosNodeExtension({
    groups: [
      "spoilerable",
      "overlay",
      "not-overtypable",
      "resizable",
      "custom-styles",
      "draggable"
    ],
    type: "react-node",
    name: TIPTAP_VIDEO_TYPE,
    reconfigure: (config, _extensions, _props, settings, services) => ({
      ...config,
      addOptions: () => ({
        services,
        ...settings
      })
    }),
    Component: Video,
    placeholder: {
      predicate: ({ doc, pos, selection }) => {
        const $pos = doc.resolve(pos);
        const parentNode = $pos.parent;
        if (parentNode.type.name !== TIPTAP_FIGURE_TYPE) {
          return false;
        }
        const isCurrNodeSelected = selection.from <= pos && selection.to >= pos && parentNode.firstChild?.type.name === TIPTAP_VIDEO_TYPE;
        const isCaptionFocused = selection.from === selection.to;
        return isCurrNodeSelected && !isCaptionFocused;
      },
      priority: 1,
      content: "Video_Caption_Input_Placeholder",
      alwaysVisible: true,
      alignCenter: true
    },
    createExtensionConfig() {
      return {
        name: this.name,
        /*
         * Priority should be higher than ricos-common-plugin list-item extension in order
         * to shortcuts to work
         */
        priority: 102,
        group: "block figureFirstChildContent",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          containerData: null,
          video: null,
          thumbnail: null,
          disableDownload: null,
          disableExpand: null,
          title: null,
          options: null,
          loading: {
            default: false
          },
          error: null,
          loadingPercentage: null,
          tempData: null,
          uploadToken: null
        }),
        addKeyboardShortcuts() {
          const newLine = ({ editor }) => {
            const videoFigure = getVideoFigure(editor);
            if (!videoFigure) {
              return false;
            }
            editor.chain().setTextSelection(videoFigure.start + videoFigure.node.nodeSize - 1).createParagraphNear().focus().run();
            return true;
          };
          const tiptapKeyboardShortcuts = {
            Enter: newLine
          };
          const newLineShortcuts = [];
          this.options.services.shortcuts.shortcuts.forEach((shortcut) => {
            if (shortcut.shortcut.name === "NewLine") {
              newLineShortcuts.push(shortcut);
            }
          });
          newLineShortcuts.forEach((newLineShortcut) => {
            const modifier = newLineShortcut.keys.macOs.modifiers[0];
            const key = newLineShortcut.keys.macOs.key;
            const shortcutKey = modifier ? `${modifier}-${key}` : key;
            tiptapKeyboardShortcuts[shortcutKey] = newLine;
          });
          return tiptapKeyboardShortcuts;
        },
        addCommands() {
          return {};
        }
      };
    }
  })
];
const getVideoFigure = (editor) => findParentNodeClosestToPos(
  editor.state.selection.$from,
  (node) => node.type.name === TIPTAP_FIGURE_TYPE
);
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
